export const ACTION_TYPE_ALERT = 'Alert';
export const ALERT_TYPE_KEY = 'AlertType';
export const SEVERITY_INITIAL_VALUE = 'Informational';

export const RuleNodeType = {
  GROUP: 'ruleGroup',
  RULE: 'rule',
};
